import React from 'react';

const CustomModal = ({
  open,
  onClose,
  title,
  children,
  confirmText = 'Aceptar',
  onConfirm
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 custom-modal-bg flex items-center justify-center">
      <div className="custom-modal-content">
        <button
          className="custom-modal-close"
          onClick={onClose}
        >
          &times;
        </button>
        <h2 className="custom-modal-title">{title}</h2>
        <div className="custom-modal-body">
          {children}
        </div>
        <div className="flex justify-center">
          <button
            className="custom-modal-btn"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomModal; 